var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(-308 -12)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18 7.147L16.853 6 12 10.853 7.147 6 6 7.147 10.853 12 6 16.853 7.147 18 12 13.147 16.853 18 18 16.853 13.147 12z",
      "transform": "translate(308 12)"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }